import React, { useState, useEffect } from 'react';
import { css } from '@emotion/react';
import MoneyIcon from '@images/money-icon.svg';
import FoodIcon from '@images/food-icon.svg';
import WaterIcon from '@images/water-icon.svg';

const id = 'calculator';

const LabelCSS = css`
  font-weight: 300;
`;
const NumberCSS = css`
  font-weight: bold;
  margin-bottom: 0;
  font-size: 2rem;
  margin-bottom: -0.5rem;
`;

const SavingsValues = {
  PINPOINT: 'pinpoint',
  SAVED_MONEY: 'saved_money',
  SAVED_FOOD: 'saved_food',
  SAVED_WATER: 'saved_water'
};

export default function Calculator({ data }) {

  const [revenue, setRevenue] = useState(10000);
  const [savedMoney, setSavedMoney] = useState(0);
  const [savedFood, setSavedFood] = useState(0);
  const [savedWater, setSavedWater] = useState(0);

  const handleRevenueChange = (e) => {
    setRevenue(e.target.value);
  };

  const calculateCosts = (args) => {
    const { pinpoints } = data;
    let value = revenue / pinpoints[1][SavingsValues.PINPOINT] - pinpoints[0][SavingsValues.PINPOINT];
    return (value * (pinpoints[1][args] - pinpoints[0][args])).toFixed(2);
  };

  useEffect(() => {
    setSavedMoney(Math.round(calculateCosts(SavingsValues.SAVED_MONEY)));
    setSavedFood(Math.round(calculateCosts(SavingsValues.SAVED_FOOD)));
    setSavedWater(Math.round(calculateCosts(SavingsValues.SAVED_WATER)));
  }, [revenue]);

  return (
    <div id={id} className="container py-5">
      <div
        className="text-center"
        css={css`
          font-size: 2rem;
        `}
        dangerouslySetInnerHTML={{ __html: data.title }}
      />
      <div>
        <div
          className="text-center"
          css={css`
            text-transform: uppercase;
            color: #ffffff;
            font-size: 1rem;
            font-weight: bold;
            letter-spacing: 1.16px;
          `}
        >
          <label htmlFor="revenue">
            {data.label}
          </label>
        </div>
        <div
          css={css`
            text-align: center;
            font-size: 2rem;
            font-weight: bold;
          `}
        >
          {revenue}
        </div>
        <input
          type="range"
          min="10000"
          max="200000"
          id="revenue"
          step="1000"
          className="custom-range my-4 mx-auto"
          css={css`
            max-width: 700px;
            display: block;
          `}
          onChange={handleRevenueChange}
        />
      </div>
      <div
        className="my-4 text-center"
        css={css`
          font-size: 1.5rem;
          font-weight: 300;
        `}
      >
        {data.savings_header}
      </div>
      <div className="row py-4 mb-3">
        <div className="text-center col-12 col-md-4 mb-5 mb-md-0">
          {/* TODO: alt i18n */}
          <img
            alt="money icon"
            src={MoneyIcon}
            className="mb-3"
            css={css`
              width: 100px;
            `}
          />
          <div css={NumberCSS}>
            {savedMoney}
          </div>
          <div css={LabelCSS}>{data.savings_money_label}</div>
        </div>
        <div className="text-center col-12 col-md-4 mb-5 mb-md-0">
          {/* TODO: alt i18n */}
          <img
            alt="food icon"
            src={FoodIcon}
            className="mb-3"
            css={css`
              width: 100px;
            `}
          />
          <div css={NumberCSS}>{savedFood}</div>
          <div css={LabelCSS}>{data.savings_food_label}</div>
        </div>
        <div className="text-center col-12 col-md-4 mb-5 mb-md-0">
          {/* TODO: alt i18n */}
          <img
            alt="water icon"
            src={WaterIcon}
            className="mb-3"
            css={css`
              width: 100px;
            `}
          />
          <div css={NumberCSS}>{savedWater}</div>
          <div css={LabelCSS}>{data.savings_water_label}</div>
        </div>
      </div>
      <div
        css={css`
          color: #282c30;
          text-align: center;
          font-size: 0.7rem;
          span {
            color: #ffffff;
            font-weight: bold;
          }
        `}
      >
        {/* FIXME: Want to know more? See our <span>Advanced Calculator</span>*/}
      </div>
    </div>
  );
}